import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Service";
import Contact from "./pages/Contact";
import About from "./pages/AboutUs";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import FAQPage from "./pages/FAQPage";
import Projects from "./pages/Projects";
import Navbar from './components/Navbar';
import StickyNavbar from './components/StickyNavbar';
import Footer from './components/Footer';
import "./assets/css/style.css";
import SocialButtons from "./components/SocialButtons";

import ScrollToTop from "./components/ScrollToTop";

import { WebsiteSettingsProvider } from "./contexts/WebsiteSettingsContext";

function App() {
  return (
    <WebsiteSettingsProvider>
      <BrowserRouter>
        <ScrollToTop />
        <SocialButtons />

        <div className="relative z-[9999]">
          <Navbar />
          <StickyNavbar />
        </div>

        
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/projects" element={<Projects />} />
          </Routes>


        {/* <Footer /> */}
      </BrowserRouter>
    </WebsiteSettingsProvider>
  );
}

export default App;
